var ControlKit        = require('./lib/ControlKit');
	ControlKit.Canvas = require('./lib/component/Canvas');
	ControlKit.SVG    = require('./lib/component/SVG');

module.exports = ControlKit;